import React from 'react';
export function TopBar() {
  return <div className="bg-blue-700 text-white text-center text-sm py-2 px-4" data-id="element-254">
      ⏰ Precio de lanzamiento por tiempo limitado — Después sube $10.000 ARS y
      no vuelve a bajar
    </div>;
}